/**
 *  KeywordSelector script file
**/

import { KEYWORD_LEVELS } from '@/api/googleAdsService'
import {
  GETTERS as GETTERS_KEYWORDS,
  MODULE_NAME as MODULE_NAME_KEYWORDS,
  MUTATIONS as MUTATIONS_KEYWORDS
} from '@/store/keywords'
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'KeywordSelector',
  mixins: [],
  components: {
    KeywordSelectorItem: () => import('@/components/keyword-selector-item/KeywordSelectorItem.vue')
  },
  props: {
    selection: {
      type: Array,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(MODULE_NAME_KEYWORDS, ['selectedMap']),
    ...mapGetters(MODULE_NAME_KEYWORDS, {
      selected: GETTERS_KEYWORDS.GET_SELECTED_ITEMS
    })
  },
  watch: {
    selected (value) {
      this.$emit('selected', value)
    }
  },
  mounted () {
    for (const id of this.selection) {
      const key = `${KEYWORD_LEVELS[3]}-${id}`
      if (!this.selectedMap[key]) {
        this.toggleSelection(id, true)
      }
    }
  },
  beforeDestroy () {
    this[MUTATIONS_KEYWORDS.RESET_TREE]()
  },
  methods: {
    ...mapMutations(MODULE_NAME_KEYWORDS, Object.values(MUTATIONS_KEYWORDS)),
    toggleSelection (id, flag) {
      const key = `${KEYWORD_LEVELS[3]}-${id}`
      this[MUTATIONS_KEYWORDS.SET_SELECTED]({
        key,
        flag
      })
    }
  }
}
